<template>
  <transition name="fade">
    <div class="userModal" v-if="show" v-on:click="modalClicked">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4 v-if="detail">Edit Form Field</h4>
        <h4 v-else>Add New Form Field</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldGroup fg2b">
            <div class="fieldCnt" :class="{hasError: form.label.error}">
              <label>Label</label>
              <input type="text" class="field" placeholder="Field label..."
                v-model="form.label[lang]" v-on:input="fieldChanged('label')">
              <div class="fieldError">Please input field label.</div>
            </div>
            <div class="fieldCnt">
              <label>Type</label>
              <select class="field" v-model="form.type.model">
                <option value="text">Short answer</option>
                <option value="textarea">Long answer</option>
                <option value="checkbox">Checkboxes</option>
                <option value="select">Dropdown</option>
                <option value="date">Date</option>
              </select>
            </div>
          </div>
          <div class="fieldGroup fg2b">
            <div class="fieldCnt" :class="{hasError: form.placeholder.error}">
              <label>Placeholder</label>
              <input type="text" class="field" placeholder="Field placeholder..."
                v-model="form.placeholder[lang]" v-on:input="fieldChanged('placeholder')">
            </div>
            <div class="fieldCnt">
              <div class="toggle">
                <div class="radioItem" :class="{on: isRequired}"
                  v-on:click="isRequired = !isRequired">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Mandatory
                </div>
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt" :class="{hasError: form.hint.error}">
              <label>Hint</label>
              <input type="text" class="field" placeholder="Field hint..."
                v-model="form.hint[lang]" v-on:input="fieldChanged('hint')">
            </div>
          </div>
          <div v-if="form.type.model === 'select' || form.type.model === 'checkbox'">
            <div class="fieldGroup fieldGroupBos" v-for="(o, i) in options" :key="i">
              <div class="answerDelete" v-on:click="deleteAnswer(i)"></div>
              <div :class="{fieldCnt: true, hasError: false}">
                <label>Option</label>
                <input type="text" class="field" placeholder="Write option..."
                  v-model="o.model">
              </div>
            </div>
            <div class="addMoreAnswer" v-on:click="addMoreAnswer">
              + Add more option
            </div>
          </div>
          <div class="btnCnt">
            <div class="langSelectorBtn"
              v-on:click.stop="langSelectorOpen = !langSelectorOpen">
              <b>{{lang}}</b>
              <div class="langSelector" v-if="langSelectorOpen"
                v-on:click.stop="doNothing">
                <li v-on:click.stop="selectLang('en')">EN - English</li>
                <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
              </div>
            </div>

            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!saving">
              Cancel
            </button>
            <button class="btn btnPrimary" :class="{btnLoading: saving}"
              v-if="detail" type="submit">
              <span>Save Changes</span>
            </button>
            <button class="btn btnPrimary" :class="{btnLoading: saving}"
              v-else type="submit">
              <span>Add Field</span>
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  components: { MediaSelector },
  data() {
    return {
      loading: false,
      show: false,
      saving: false,
      options: [],
      content: null,
      detail: null,
      isRequired: false,
      form: {
        label: { id: '', en: '', error: null },
        type: { model: 'text' },
        placeholder: { id: '', en: '', error: null },
        hint: { id: '', en: '', error: null },
      },
      lang: 'id',
      langSelectorOpen: false,
    };
  },
  methods: {
    modalClicked() {
      this.langSelectorOpen = false;
    },
    selectLang(lang) {
      this.langSelectorOpen = false;
      this.lang = lang;
    },
    open(d, n) {
      this.detail = d;
      this.form.label.id = (d && d.label) ? d.label.id : '';
      this.form.label.en = (d && d.label) ? d.label.en : '';
      this.form.label.error = null;
      this.form.hint.en = (d && d.hint) ? d.hint.en : '';
      this.form.type.model = (d && d.type) ? d.type : 'text';
      this.form.placeholder.id = (d && d.placeholder) ? d.placeholder.id : '';
      this.form.placeholder.en = (d && d.placeholder) ? d.placeholder.en : '';
      this.lang = 'id';
      this.isRequired = (d) ? d.isRequired : null;
      if (d && d.options) {
        this.options = [];
        // eslint-disable-next-line
        for (const opt of d.options) {
          this.options.push({ model: opt.label });
        }
      } else {
        this.options = [{ model: '' }, { model: '' }, { model: '' }];
      }
      this.next = n;
      this.show = true;
      this.saving = false;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    deleteAnswer(i) {
      this.options.splice(i, 1);
      if (this.options.length < 1) this.addMoreAnswer();
    },
    addMoreAnswer() {
      this.options.push({ model: '' });
    },
    handleSubmit() {
      /**
       * Deprecated
       * Label now become optional
       *
       */
      // if (this.form.label[this.lang].trim() === '') {
      //   this.form.label.error = 'Please input label to continue.';
      //   return;
      // }
      const formData = {
        type: this.form.type.model,
        error: { id: null, en: null },
        model: { id: '', en: '' },
        label: { id: this.form.label.id, en: this.form.label.en },
        hint: { id: this.form.hint.id, en: this.form.hint.en },
        placeholder: {
          id: this.form.placeholder.id,
          en: this.form.placeholder.en,
        },
        isRequired: this.isRequired,
        options: [],
      };
      // eslint-disable-next-line
      for (const o of this.options) {
        if (o.model && o.model !== '') {
          formData.options.push({
            selected: false,
            label: o.model,
          });
        }
      }
      this.close(true, formData);
    },
    fieldChanged(field) {
      this.form[field].error = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;

    .fieldCnt.hasError{
      .field{
        border-color: red;
      }
      .fieldError{
        display: block;
      }
    }
    .fieldCnt.hasPrefix{
      position: relative;
      .field{
        padding-left: 40px;
      }
      .fieldPrefix{
        position: absolute;
        left: 10px; top: 35px;
        z-index: 3;
        color: #767676;
      }
    }

    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      h4{
        font-size: 24px;
        margin: 0;
        margin-bottom: 20px;
      }
      .fieldGroup{
        .toggle{
          margin-top: 30px;
        }
        &.fg2b{
          .fieldCnt:first-child{
            width: calc(60% - 12px);
          }
          .fieldCnt:last-child{
            width: calc(40% - 12px);
          }
        }
      }
      .btnCnt{
        text-align: right;
        border-top: #eee 1px solid;
        margin: 0 -80px -40px;
        padding: 12px 30px;
        display: flex;
        align-items: center;
        .langSelectorBtn{
          margin-right: auto;
          position: relative;
          border-radius: 50px;
          padding: 6px 16px;
          padding-left: 36px;
          transition: all .3s ease;
          cursor: pointer;
          margin-right: auto;
          &:hover{
            background-color: #f5f5fe;
          }
          &:before{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/language.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          b{
            font-weight: 600;
            text-transform: uppercase;
          }
          .langSelector{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            bottom: 100%; left: 0;
            box-shadow: 0 0 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 8px 0;
            text-align: left;
            li{
              white-space: nowrap;
              list-style: none;
              padding: 8px 24px;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .btn{
          margin-left: 5px;
          &.saving{
            background-color: #ccc;
            color: #999;
            cursor: default;
            box-shadow: none;
          }
        }
      }
    }
  }

  .addMoreAnswer{
    margin-bottom: 24px;
    padding: 4px 14px 5px;
    border-radius: 50px;
    display: inline-block;
    font-size: 15px;
    color: #767676;
    transition: all .3s ease;
    cursor: pointer;
    &:hover{
      background-color: #eee;
      color: #0747a6;
    }
  }

  .modalContent.modalBig{
    width: 480px;
    padding: 40px 80px;
    .fieldGroupBos{
      position: relative;
      margin-bottom: 10px;
      .answerDelete{
        width: 34px; height: 34px;
        position: absolute;
        right: -40px; top: 30px;
        border-radius: 50%;
        background-image: url(../assets/delete-black.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        transition: all .3s ease;
        cursor: pointer;
        &:hover{
          background-color: #ddd;
          opacity: .7;
        }
      }
    }
    .fieldGroup2{
      .fieldCnt{
        float: left;
        width: calc(50% - 10px);
      }
      .fieldCnt.fieldCnt1{
        margin-right: 20px;
      }
    }
    .logoCnt{
      padding-left: 90px;
      height: 70px;
      position: relative;
      padding-top: 18px;
      box-sizing: border-box;
      .logo{
        border: #eee 1px solid;
        width: 70px;
        height: 70px;
        border-radius: 5px;
        position: absolute;
        left: 0; top: 0;
        cursor: pointer;
        background-color: #eee;
        font-weight: bold;
        font-size: 20px;
        color: #bbb;
        text-align: center;
        padding-top: 20px;
        box-sizing: border-box;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        &.logoProfile{
          border-radius: 50%;
          background-size: cover;
        }
        &.hasLogo{
          background-color: #fff;
          span{
            display: none;
          }
        }
        &:hover{
          border-color: #ddd;
        }
      }
      .addLogo{
        border: #0057d8 1px solid;
        border-radius: 4px;
        background-color: #fff;
        color: #0057d8;
        padding: 8px 12px;
        cursor: pointer;
        &:hover{
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        }
      }
    }
  }
</style>
